import { ApplicationTag, ApplicationType, Product } from "@app/views-interfaces";

export interface IDashboardModel {
    ApplicationType: number;
    BootstrapDate: number;
    ClientCode: string;
    CreationDate: number;
    DatabaseName: string;
    DaysBeforeDeadlineAlert: number;
    DaysBeforeDeadlineWarning: number;
    DaysInStepAlert: number;
    DaysInStepWarning: number;
    DisplayGroupedCards: boolean;
    DisplayCardBasedOn: DisplayCardBasedOn;
    ReturnStatusDefaultValue: boolean;
    AssignedStatusDefaultValue: boolean;
    Id: string;
    IsSupportEnabled: boolean;
    Status: string;
    SupportsMultiCard: boolean;
    Title: string;
    TaxYear: number | null;
    AssignCategoryNoTags: boolean;
    AssignCategoryId: string;
    AutomaticSyncOpen: boolean;
    AutomaticSyncClose: boolean;
    CardCategoryDisplayPreference: CardCategoryDisplayPreference;
}

export enum DisplayCardBasedOn {
    MainTaxpayer = 0,
    LeastAdvanced = 1,
}

export enum CardCategoryDisplayPreference {
    MainTaxpayer = 0,
    MostComplex = 1,
}

export function isiFirmTaxDashboard(dashboard: IDashboardModel | undefined): boolean {
    switch (dashboard?.ApplicationType) {
        case ApplicationType.iFirmTaxT1:
        case ApplicationType.iFirmTaxT2:
        case ApplicationType.iFirmTaxT3:
        case ApplicationType.iFirmTaxForms:
            return true;
        default:
            return false;
    }
}

export function isTaxprepDashboard(dashboard: IDashboardModel | undefined): boolean {
    switch (dashboard?.ApplicationType) {
        case ApplicationType.TaxprepT1:
        case ApplicationType.TaxprepT2:
        case ApplicationType.TaxprepT3:
        case ApplicationType.TaxprepForms:
            return true;
        default:
            return false;
    }
}

export function isJobsBillingDashboard(dashboard: IDashboardModel | undefined): boolean {
    return dashboard?.ApplicationType === ApplicationType.JobsBilling;
}

// Interfaces for API responses and internal data structures

export enum DashboardStatus {
    Activated = 0,
    Suspended = 1,
    Closed = 2,
    Trial = 3,
    Expired = 4,
}

export interface IDashboardApiResponse {
    Code: number;
    Dashboards: IDashboardModel[];
}

export interface IDashboardUpdateRequest {
    AssignCategoryNoTags?: boolean;
    AssignCategoryId?: string;
    [key: string]: unknown;
}

export interface IDashboardUpdateResponse {
    Code: number;
    Message?: string;
    Dashboard?: IDashboardModel;
}

/* dashboard-activation-service expects application type as string in one of two formats:
 * 1. '<application> <product> <year>' like 'Taxprep T1 2026', 'iFirmTax T1 2025'
 * 2. '<application>' like 'JobsBilling', 'Taxprep', 'iFirmTax'
 * Property names are derived from dashboard-activation-service terminology.
 * Also, refer to ApplicationType.enum for mapping between application types and their string representations.
 * This comment can (and should) be removed once front-end and back-end are aligned on the same data structure and naming conventions.
 */
export interface IDashboardCreateRequest {
    Title: string;
    ApplicationTag: ApplicationTag;
    Product?: Product;
    Year?: string;
}

export interface IDashboardCreateMessage extends IDashboardCreateRequest {
    msgId: string;
}

export interface IDashboardCreateResponse {
    status: string;
}

export interface IDashboardSyncSettings {
    AutomaticSyncOpen: boolean;
    AutomaticSyncClose: boolean;
}

export interface IUserDashboardSettingsRequest {
    Active?: boolean;
    Id?: string;
    DashboardId: string;
    UserId: string;
    Title: string;
    Settings: IDashboardSyncSettings;
}
